import Vue from "vue";
import Fullscreen from "vue-fullscreen";

Vue.use(Fullscreen);
